import React from 'react';
import OnOffNoLabel from './OnOffNoLabel';

const ToggleNoLabel = ({
  checked,
  label,
  className,
  disabled,
  message = 'hidden.label.toggle',
  onClick,
}) => (
  <OnOffNoLabel
    disabled={disabled}
    message={message}
    toggle
    checked={checked}
    label={label}
    className={className}
    onClick={disabled ? undefined : onClick}
  />
);

export default ToggleNoLabel;
